import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class VisitorsDevicesPrintersOverviewRoute extends Route {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('printer-overview-web')) {
      void this.router.transitionTo('visitors.devices.printers.index');
    }
  }
}
